{
  "household_name": "Andre's household",
  "quarter_human": "Q2 2026",
  "tax_year": "2026",
  "projected_total_human": "$28,420",
  "projected_federal_human": "$18,210",
  "projected_ny_human": "$6,820",
  "projected_nyc_human": "$3,390",
  "projected_annual_ordinary_human": "$220,000",
  "projected_annual_qdivs_human": "$8,400",
  "projected_annual_ltcg_human": "$12,000",
  "composite_effective_rate_pct": "24.6",
  "composite_marginal_rate_pct": "32.0",
  "safe_harbor_safe": true,
  "safe_harbor_status_human": "On track for 110% of prior-year safe-harbor",
  "safe_harbor_shortfall_human": "$0",
  "tax_url": "https://dev.hearthfire.ai/tax"
}
